import { render, staticRenderFns } from "./bnjf.vue?vue&type=template&id=658388b0&scoped=true&"
import script from "./bnjf.vue?vue&type=script&lang=js&"
export * from "./bnjf.vue?vue&type=script&lang=js&"
import style0 from "./bnjf.vue?vue&type=style&index=0&id=658388b0&lang=less&scoped=true&"
import style1 from "./bnjf.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658388b0",
  null
  
)

export default component.exports